import React from "react";
import { useSnapshot } from "valtio";
import { useTemplateData } from "@constants/template";
import { templateStore } from "@pages/Applications/C&C/C&CSetup/templateStore";
import PhoneFrameTwo from "../../Common/PhoneFrameTwo";
import { store } from "../../Website/CoverPage/store";
import { NoPicture } from "@components/Common/SvgIcons";
import { GiftIcon } from "@components/Common/SvgIcons/GiftIcon";
import { QrcodeIcon } from "@components/Common/SvgIcons/QrcodeIcon";
interface PreviewProps {
    shopData?: any;
}
function Preview({ shopData = {} }: PreviewProps) {
    const { selectedLanguage } = useSnapshot(store);

    const { getImageUrl, iuud, getNestedValue } = useTemplateData();
    const color = getNestedValue<string>([
        "Application",
        "Divers",
        "CouleurPrincipale",
    ]);
    const imageUrl = getImageUrl(
        [
            "Application",
            "Loyalty",
            shopData.boutique || "Default",
            "Head",
            "Bannier",
        ],
        iuud
    );
    const logoUrl = getImageUrl(
        [
            "Application",
            "Loyalty",
            shopData.boutique || "Default",
            "Avantages",
            "Image",
        ],
        iuud
    );
    const snap = useSnapshot(templateStore);
    function getNesteddValue(
        path: string[],
        field: string,
        lang: string,
        obj: any,
        isMultilingual: boolean = true
    ): any {
        try {
            let current = obj;
            for (const key of path) {
                if (current[key] === undefined) return "";
                current = current[key];
            }

            if (!current[field]) return "";

            return isMultilingual ? current[field][lang] || "" : current[field];
        } catch {
            return "";
        }
    }
    const slodeBottomTitle = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "Loyalty", shopData.boutique || "Default", "Solde"],
            "BottomTitle",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const soldeInfo1 = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "Loyalty", shopData.boutique || "Default", "Solde"],
            "Info_1",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const soldeInfo2 = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "Loyalty", shopData.boutique || "Default", "Solde"],
            "Info_2",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const soldeTitle = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "Loyalty", shopData.boutique || "Default", "Solde"],
            "Title",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const recompenceTitle = React.useMemo(() => {
        return getNesteddValue(
            [
                "Application",
                "Loyalty",
                shopData.boutique || "Default",
                "Recompenses",
            ],
            "Title",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const recompenceBottomTitle = React.useMemo(() => {
        return getNesteddValue(
            [
                "Application",
                "Loyalty",
                shopData.boutique || "Default",
                "Recompenses",
            ],
            "BottomTitle",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const advantageTitle = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "Loyalty", "Default", "Avantages"],
            "Title",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage]);
    const advantageInfo_1 = React.useMemo(() => {
        return getNesteddValue(
            [
                "Application",
                "Loyalty",
                shopData.boutique || "Default",
                "Avantages",
            ],
            "Info_1",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const advantageInfo_2 = React.useMemo(() => {
        return getNesteddValue(
            [
                "Application",
                "Loyalty",
                shopData.boutique || "Default",
                "Avantages",
            ],
            "Info_2",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <PhoneFrameTwo>
                <div style={{ paddingBottom: "50px" }}>
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt=""
                            style={{
                                width: "100%",
                                height: "40%",
                                display: "block",
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <NoPicture height={250} width={250} />
                        </div>
                    )}
                    <div style={{ padding: "5px 10px " }}>
                        <h5
                            style={{
                                fontWeight: "bold",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                fontSize: "18px",
                            }}
                        >
                            {soldeTitle}
                        </h5>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px ",
                                border: "0.5px solid #615d5d",
                                borderRadius: "10px",
                            }}
                        >
                            <h6
                                style={{
                                    fontWeight: "bold",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                }}
                            >
                                {soldeInfo1}
                            </h6>
                            <h6
                                style={{
                                    fontWeight: "bold",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                }}
                            >
                                20 {soldeInfo2}
                            </h6>
                        </div>
                        <div
                            style={{
                                padding: "8px 12px",
                                border: `0.5px solid ${color}`,
                                borderRadius: "10px",
                                margin: "10px 0px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <h6
                                style={{
                                    fontWeight: "bold",
                                    color: `${color}`,
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    margin: 0,
                                }}
                            >
                                {" "}
                                {slodeBottomTitle}
                            </h6>
                            <QrcodeIcon
                                width={28}
                                height={28}
                                fill={`${color}`}
                            />
                        </div>
                        <h6
                            style={{
                                fontWeight: "bold",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                            }}
                        >
                            {recompenceTitle}
                        </h6>
                        <div
                            style={{
                                padding: "8px 12px ",
                                borderRadius: "10px",
                                backgroundColor: `${color}`,
                                margin: "10px 0px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <p
                                style={{
                                    color: "#fff",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    margin: 0,
                                }}
                            >
                                {recompenceBottomTitle}
                            </p>
                            <GiftIcon width={24} height={24} fill="#fff" />
                        </div>
                        <h6
                            style={{
                                fontWeight: "bold",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                            }}
                        >
                            {advantageTitle}
                        </h6>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap",
                            }}
                        >
                            <h6 style={{ fontWeight: "bold" }}>Boissons</h6>
                            <div
                                style={{
                                    flexGrow: 1,
                                    height: "1px",
                                    backgroundColor: "#0e0d0d",
                                    margin: "0 10px",
                                }}
                            />
                            <h6
                                style={{
                                    fontWeight: "bold",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                }}
                            >
                                150 {soldeInfo2}
                            </h6>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                                flexWrap: "wrap",
                                marginTop: "15px",
                            }}
                        >
                            <div
                                style={{
                                    height: "200px",
                                    width: "100px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "space-between",
                                    borderRadius: "10px",
                                    border: "1px gray solid",
                                    padding: "5px",
                                    position: "relative",
                                    boxShadow:
                                        "0 5px 5px -5px rgba(0, 0, 0, 0.3)",
                                }}
                            >
                                <img
                                    src="/images/fanta.png"
                                    alt="fanta"
                                    style={{ width: "100%", height: "50%" }}
                                />
                                {logoUrl && (
                                    <img
                                        src={logoUrl}
                                        alt=""
                                        style={{
                                            position: "absolute",
                                            top: "5%",
                                            left: "25%",
                                            width: "50%",
                                            height: "50%",
                                            opacity: 0.7,
                                            zIndex: 2,
                                            borderRadius: "10px 10px 0 0",
                                        }}
                                    />
                                )}
                                <p
                                    style={{
                                        position: "absolute",
                                        zIndex: 10,
                                        textAlign: "center",
                                        width: "100%",
                                        top: "30%",
                                        left: "0",
                                        color: "black",
                                        backgroundColor:
                                            "rgba(218, 209, 209, 0.5)",
                                        padding: "2px 0",
                                        wordWrap: "break-word",
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    150 {advantageInfo_2}
                                </p>
                                <p style={{ textAlign: "center" }}>
                                    Fanta 33cl
                                </p>
                                <p style={{ textAlign: "center" }}>
                                    {advantageInfo_1} 130 {advantageInfo_2}
                                </p>
                            </div>
                            <div
                                style={{
                                    height: "200px",
                                    width: "100px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "space-between",
                                    borderRadius: "10px",
                                    border: "1px gray solid",
                                    padding: "5px",
                                    position: "relative",
                                    boxShadow:
                                        "0 5px 5px -5px rgba(0, 0, 0, 0.3)",
                                }}
                            >
                                <img
                                    src="/images/sprite.png"
                                    alt="sprite"
                                    style={{ width: "100%", height: "50%" }}
                                />
                                {logoUrl && (
                                    <img
                                        src={logoUrl}
                                        alt=""
                                        style={{
                                            position: "absolute",
                                            top: "5%",
                                            left: "25%",
                                            width: "50%",
                                            height: "50%",
                                            opacity: 0.7,
                                            zIndex: 2,
                                            borderRadius: "10px 10px 0 0",
                                        }}
                                    />
                                )}
                                <p
                                    style={{
                                        position: "absolute",
                                        zIndex: 10,
                                        textAlign: "center",
                                        width: "100%",
                                        top: "30%",
                                        left: "0",
                                        color: "black",
                                        backgroundColor:
                                            "rgba(218, 209, 209, 0.5)",
                                        padding: "2px 0",
                                        wordWrap: "break-word",
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    150 {advantageInfo_2}
                                </p>
                                <p style={{ textAlign: "center" }}>
                                    Sprite 33cl
                                </p>
                                <p style={{ textAlign: "center" }}>
                                    {advantageInfo_1} 130 {advantageInfo_2}
                                </p>
                            </div>
                            <div
                                style={{
                                    height: "200px",
                                    width: "100px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "space-between",
                                    borderRadius: "10px",
                                    border: "1px gray solid",
                                    padding: "5px",
                                    position: "relative",
                                    boxShadow:
                                        "0 5px 5px -5px rgba(0, 0, 0, 0.3)",
                                }}
                            >
                                <img
                                    src="/images/tropical.png"
                                    alt="tropical"
                                    style={{ width: "100%", height: "50%" }}
                                />
                                {logoUrl && (
                                    <img
                                        src={logoUrl}
                                        alt=""
                                        style={{
                                            position: "absolute",
                                            top: "5%",
                                            left: "25%",
                                            width: "50%",
                                            height: "50%",
                                            opacity: 0.7,
                                            zIndex: 2,
                                            borderRadius: "10px 10px 0 0",
                                        }}
                                    />
                                )}
                                <p
                                    style={{
                                        position: "absolute",
                                        zIndex: 10,
                                        textAlign: "center",
                                        width: "100%",
                                        top: "30%",
                                        left: "0",
                                        color: "black",
                                        backgroundColor:
                                            "rgba(218, 209, 209, 0.5)",
                                        padding: "2px 0",
                                        wordWrap: "break-word",
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    150 {advantageInfo_2}
                                </p>
                                <p
                                    style={{
                                        textAlign: "center",
                                        marginTop: "5px",
                                    }}
                                >
                                    Tropical 33cl
                                </p>
                                <p style={{ textAlign: "center" }}>
                                    {advantageInfo_1} 130 {advantageInfo_2}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </PhoneFrameTwo>
        </div>
    );
}

export default Preview;
